import { env } from '../config/env'

export function deriveAdvisorEnabled(raw: string | undefined): boolean {
  return raw === 'true'
}

export function deriveAdvisorRelayUrl(raw: string | undefined): string {
  return (raw ?? '').replace(/\/$/, '')
}

export const ADVISOR_ENABLED = deriveAdvisorEnabled(env.VITE_ADVISOR_ENABLED)
export const ADVISOR_RELAY_URL = deriveAdvisorRelayUrl(env.VITE_ADVISOR_RELAY_URL)

/**
 * Single pinned advisor model (R5). The relay guardrail must agree:
 * infra/advisor-relay/config.go ALLOWED_MODEL (default claude-opus-4-8) rejects
 * anything else with a 400 — change BOTH or neither.
 */
export const ADVISOR_MODEL = 'claude-opus-4-8'
